import React, { PropsWithChildren, ReactNode } from 'react'

import { bemJoin } from 'bem-join'

import './Sidebar.scss'

export type SidebarProps = {
  sidebar: ReactNode
  isVisible?: boolean
}

const b = bemJoin('sidebar')

export const Sidebar = ({ children, sidebar, isVisible }: PropsWithChildren<SidebarProps>) => {
  return (
    <div
      className={b({
        visible: isVisible
      })}
    >
      <main className={b('main')}>{children}</main>
      {isVisible && <aside className={b('aside')}>{sidebar}</aside>}
    </div>
  )
}
